import { UseQueryListDeliveriesParams } from '../../deliveries.queries';
import { ListPageHeaderProps } from '../../../../ui/components/pure/page-headers/list/list-page-header.component';
import { KnownDeliveryDtoDeliveryType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { CustomDeliveryStateOptions, deliveryStatusToLabelWithCategory } from '../../deliveries.constants';
import { Permissions } from '../../../../core/permissions/permissions.typings';
import { deliveryTypeToLabelMap } from '../../maps/delivery-type-to-label.map';

export function makeDeliveriesListPageHeaderProps(
  projectID: string,
  deliveriesCount: number,
  onClickReceiveDelivery: () => void,
  form: UseQueryListDeliveriesParams,
  onFormInput: (update: Partial<UseQueryListDeliveriesParams>) => void,
  hubFilter: { options: { label: string; value: string }[]; loading: boolean; onOpen(): void },
  carrierFilter: { options: { label: string; value: string }[]; loading: boolean; onOpen(): void },
  showReceiveDeliveryButton: boolean
): ListPageHeaderProps<UseQueryListDeliveriesParams> {
  return {
    title: 'Deliveries',
    subtitle: `${deliveriesCount} ${deliveriesCount === 1 ? 'Delivery' : 'Deliveries'}`,
    controls: {
      form,
      onFormInput,
      inputs: [
        {
          type: 'select',
          label: 'Status',
          field: 'state',
          options: DeliveryStatusOptions,
          isAdvanced: true
        },
        {
          type: 'auto-complete',
          label: 'Hub',
          field: 'hubID',
          ...hubFilter,
          isAdvanced: true,
          halfWidthOnMobile: true
        },
        {
          type: 'select',
          label: 'Type',
          field: 'deliveryType',
          options: DeliveryTypeOptions,
          isAdvanced: true,
          halfWidthOnMobile: true
        },
        {
          type: 'auto-complete',
          label: 'Carrier',
          field: 'carrierID',
          ...carrierFilter,
          isAdvanced: true,
          halfWidthOnMobile: false
        },
        {
          type: 'date-range',
          fromLabel: 'From',
          fromField: 'createdFrom',
          toLabel: 'To',
          toField: 'createdTo',
          isAdvanced: true
        },
        {
          type: 'text',
          label: 'Search',
          field: 'searchTerm'
        }
      ],
      ...(showReceiveDeliveryButton && {
        singleAction: {
          label: 'Receive Delivery',
          onClick: onClickReceiveDelivery,
          permission: {
            action: Permissions.deliveries.create,
            projectID
          }
        }
      })
    }
  };
}

export const DeliveryStatusOptions: {
  label: string;
  value: CustomDeliveryStateOptions | '';
}[] = [
  { label: 'All statuses', value: '' },
  ...[
    CustomDeliveryStateOptions.NotDelivered,
    CustomDeliveryStateOptions.Abandoned,
    CustomDeliveryStateOptions.Cancelled,
    CustomDeliveryStateOptions.CurrentDeliveriesCategory,
    CustomDeliveryStateOptions.InProgress,
    CustomDeliveryStateOptions.Delivered,
    CustomDeliveryStateOptions.Overdue,
    CustomDeliveryStateOptions.RetrievalRequired,
    CustomDeliveryStateOptions.Completed,
    CustomDeliveryStateOptions.Collected,
    CustomDeliveryStateOptions.Retrieved
  ].map((state) => ({ label: deliveryStatusToLabelWithCategory[state], value: state }))
];

const DeliveryTypeOptions: {
  label: string;
  value: KnownDeliveryDtoDeliveryType | '';
}[] = [
  { label: 'All types', value: '' },
  ...[
    KnownDeliveryDtoDeliveryType.InboundDryCleaning,
    KnownDeliveryDtoDeliveryType.OutboundDryCleaning,
    KnownDeliveryDtoDeliveryType.InboundMail,
    KnownDeliveryDtoDeliveryType.OutboundMail,
    KnownDeliveryDtoDeliveryType.InboundParcel,
    KnownDeliveryDtoDeliveryType.PeerToPeer,
    KnownDeliveryDtoDeliveryType.RetailOrder
  ].map((state) => ({ label: deliveryTypeToLabelMap[state], value: state }))
];
